// Benchmark anchor helpers.
//
// The dashboard used to let users toggle the benchmark anchor between
// Platform and Industry via a topbar pill. That switch was removed: every
// benchmark surface now shows the platform/org baseline and additionally
// overlays the industry anchor when the `industryBenchmarking` feature is
// licensed. See BenchmarkPositionCard / FactorStrip / RiskTrendChart for
// the rendering, and FactorDetailPage for the contribution breakdown.
//
// pickAnchorValue / pickBenchmarkAvg resolve a single value from an anchor
// object, defaulting to the industry value when the platform side is
// absent, so callers never need null-guards.
//
// Postgres mapping: none. The anchor values come from `industry_benchmarks`
// (see BenchmarkPositionCard); this file is pure presentation glue.
import { useEffect, useState } from 'react';
import { FEATURES, subscribeFeatures } from './featureFlags';

// Baseline anchor used for RAG grading. Industry when the tenant is licensed
// for benchmarking, platform otherwise. This is no longer a user choice: it
// follows the licence.
export function baselineComparator() {
    return FEATURES.industryBenchmarking ? 'industry' : 'platform';
}

// Resolve the comparator value from an anchor or BENCHMARK-like object.
// Falls back to industry if the platform value isn't present.
export function pickAnchorValue(anchor, mode = baselineComparator()) {
    if (!anchor) return undefined;
    if (mode === 'platform' && anchor.platform != null) return anchor.platform;
    return anchor.industry;
}

export function pickBenchmarkAvg(benchmark, mode = baselineComparator()) {
    if (!benchmark) return undefined;
    if (mode === 'platform' && benchmark.platformAvg != null) return benchmark.platformAvg;
    return benchmark.industryAvg;
}

// Back-compat shim for callers that only need the tone baseline
// (factor RAG). Re-renders when the licence flag flips.
export default function useComparator() {
    const [mode, setMode] = useState(baselineComparator());
    useEffect(() => subscribeFeatures(() => setMode(baselineComparator())), []);
    return [mode];
}
